import { zones } from "@/mocks/cg51";
import { Reveal, SectionHeading } from "./ui";

export default function Zones() {
  return (
    <section id="zones" className="relative overflow-hidden bg-background-100 py-14 md:py-20">
      <div className="pointer-events-none absolute right-0 top-0 h-56 w-56 rounded-full bg-accent-100/60 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <SectionHeading
              eyebrow="Zone Map"
              title="分区盘点 · 按兴趣直达"
              desc="cg51 的分区盘点把内容分门别类，内娱、影视、音乐到财经圈一个不落。想省去翻找时间，从这里挑一个你感兴趣的区点进去最省力。"
            />
            <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-600">
              {["常驻 8 区", "全部可直达", "热度分钟级更新"].map((t) => (
                <span key={t} className="inline-flex items-center gap-1.5 rounded-full bg-background-50 px-3 py-1.5">
                  <i className="ri-checkbox-circle-line text-accent-600" /> {t}
                </span>
              ))}
            </div>
          </div>
        </Reveal>

        <div className="mt-9 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {zones.map((z, idx) => (
            <Reveal key={z.id} delay={(idx % 4) * 70}>
              <a
                href="#zones"
                className="group relative flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 p-5 transition-all hover:-translate-y-1 hover:border-primary-200"
              >
                <div className="flex items-start justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                    <i className={`${z.icon} text-xl`} />
                  </span>
                  <span className="font-heading text-2xl font-black text-background-300 transition-colors group-hover:text-primary-200">{String(idx + 1).padStart(2, "0")}</span>
                </div>
                <div className="mt-4">
                  <h3 className="font-heading text-lg font-bold text-foreground-950">{z.name}</h3>
                  <p className="text-[11px] font-semibold tracking-[0.18em] text-accent-700">{z.en}</p>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-foreground-700">{z.digest}</p>
                <div className="mt-auto flex items-center justify-between border-t border-background-200 pt-3 text-xs">
                  <span className="inline-flex items-center gap-1 text-foreground-500">
                    <i className="ri-stack-line text-sm" /> {z.threads} 栋专楼
                  </span>
                  <span className="inline-flex items-center gap-1 font-semibold text-primary-700">
                    进入 <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5" />
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}